import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M8.75 9.792a3.332 3.332 0 1 0 0-6.667 3.332 3.332 0 1 0 0 6.667Zm0-5c.917 0 1.667.75 1.667 1.666 0 .917-.75 1.667-1.667 1.667s-1.667-.75-1.667-1.667c0-.916.75-1.666 1.667-1.666Zm-5 10c.167-.525 2.142-1.4 4.133-1.617l1.7-1.667a7.792 7.792 0 0 0-.833-.05c-2.225 0-6.667 1.117-6.667 3.334v1.666h7.5l-1.666-1.666H3.75Zm13-4.584-4.275 4.309-1.725-1.734-1.167 1.175 2.892 2.917 5.442-5.492-1.167-1.175Z"
	})]
});
const ForwardRef = forwardRef(SvgUserCheck);
export { ForwardRef as ReactComponent };
